var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "toggle-bookmark-wrapper" }, [
    _c(
      "span",
      [
        !_vm.bookmarkRowValue.showUndo
          ? _c("font-awesome-icon", {
              staticClass: "fa-trash fa-lg",
              attrs: { icon: ["fas", "trash"] },
              on: { click: _vm.removeBookmark }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _vm.bookmarkRowValue.showUndo
      ? _c("div", { staticClass: "undo-popup" }, [
          _c("div", { staticClass: "undo-popup-card px-2 py-1" }, [
            _vm._v("\n      Bookmark removed. "),
            _c(
              "a",
              { staticClass: "undo-link", on: { click: _vm.saveBookmark } },
              [_vm._v("Undo")]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41d2c97d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41d2c97d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/pages/AutodeskOneToggleBookmarkPage.vue
// module id = null
// module chunks = 